export enum Action { GET, POST, PUT, DEL }

